module.exports = __webpack_public_path__ + "static/media/vegitables_28.ea44231e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_28.csv
// module id = 611
// module chunks = 0